// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.w-row.border[data-v-e20f16e6]{\n\n\tbackground: var(--main-gray-1);\n\tborder: 1px solid var(--main-gray-2);\n\tborder-radius: 5px;\n\tpadding: 10px 5px;\n}\n.dc-switch[data-v-e20f16e6]{\n\tbackground: #fff; border-color: var(--main-gray-2); color:var(--main-gray-6);\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
